exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.table-filters td[data-v-61301540] {\n    padding: 8px;\n}\n", ""]);

// exports
